export default {
    state: {
        email: {},
    },
    mutations: {
        'email.setEmailInfo'(state, data) {
            state.email = data
        }
    }
}
